import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { festival, navItems } from "../data/festival";
import { useTickets } from "../context/TicketsContext";
import { IconMenu, IconExternal } from "./icons";
import MobileNavDrawer from "./MobileNavDrawer";
import styles from "./SiteHeader.module.css";

export default function SiteHeader() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { open: openTickets } = useTickets();

  // Reverse-out the homepage hero: at the top, the header sits transparent
  // over the hero image; once you scroll past the fold (or land on any
  // sub-page), it solidifies into the brand teal bar.
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled;

  return (
    <header
      className={[styles.header, transparent ? styles.transparent : styles.solid]
        .join(" ")}
    >
      {/* Inner row constrains chrome content to the same column as the
          page below, so the brand and the page's first heading line up
          on the same vertical rail at every breakpoint. */}
      <div className={styles.inner}>
        <button
          type="button"
          className={styles.menuBtn}
          onClick={() => setDrawerOpen(true)}
          aria-label="Open menu"
        >
          <IconMenu />
        </button>

        <Link className={styles.brand} to="/" aria-label="Rhythms on the Rio — home">
          <span className={styles.brandTop}>Rhythms</span>
          <span className={styles.brandBot}>on the Rio</span>
        </Link>

        <nav className={styles.nav} aria-label="Primary">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.exact}
              className={({ isActive }) =>
                [styles.navItem, isActive ? styles.active : ""].join(" ")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          className={styles.tickets}
          onClick={openTickets}
        >
          <span className={styles.ticketsLabel}>Tickets</span>
          <IconExternal className={styles.ticketsIcon} />
        </button>
      </div>

      <MobileNavDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </header>
  );
}
